module.exports = __webpack_public_path__ + "img/dataManagement-2.530b06aa.png";